module.exports = __webpack_public_path__ + "static/media/1005865.e15daf49.jpg";